<template>
    <div :style="{ padding: padding }" class="empty_box">
        <img src="../../assets/common/empty_logo.png" alt="" />
        <span>{{ content || $t('message.spot.noData') }}</span>
        <el-button v-if="buttonShow" class="add_optional" @click="handleClick">
            {{ btnContent || $t('message.comC.addToWatchlist') }}
        </el-button>
    </div>
</template>
<script>
export default {
    props: {
        content: {
            type: String,
            default: ''
        },
        padding: {
            type: String,
            default: '140px 0 100px'
        },
        buttonShow: {
            type: Boolean,
            default: false
        },
        btnContent: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleClick() {
            this.$emit('handleClick');
        }
    }
};
</script>
<style lang="scss" scoped>
.empty_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    font-family: PingFang_Regular;
    font-weight: 400;
    color: #989898;
    & > img {
        width: 139px;
        height: auto;
        margin-bottom: 24px;
    }
    .add_optional {
        margin-top: 20px;
        background-color: $basicColor;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 500;
        color: #1e1e1e;
        padding: 10px 39px;
    }
}
</style>
